export default {
  categories: [
    "General Stacks",
    "Adul Wichiencharoen Room",
    "Charnvit Kasetsiri Room",
    "Circulation Counter",
    "Fiction Stacks",
    "India Corner",
    "Pakistan Corner",
    "Puey Ungphakorn Corner",
    "Reference Stacks",
    "Rewat Buddhinan Music Room",
    "Special Collection Room 2",
    "Special Collection Room 2: Shaiwatna Kupratakuln",
    "TRF Publications Corner",
    "Educational Media Service Center"
  ],
  checkpoints: [
    {
      text: "1 - Online public access catalog / คอมพิวเตอร์สืบค้นหนังสือ",
      value: 1
    },
    {
      text:
        "2 - Current newspapers and journals / หนังสือพิมพ์ และ วารสาร ฉบับปัจจุบัน",
      value: 2
    },
    { text: "3 - U1 level stairway / บันไดชั้น U1", value: 3 },
    { text: "4 - U1 level stairway / บันไดชั้น U1", value: 4 },
    { text: "5 - India Corner / มุมอินเดีย", value: 5 },
    { text: "6 - Pakistan Corner / มุมปากีสถาน", value: 6 },
    { text: "7 - Reference books / หนังสืออ้างอิง", value: 7 },
    { text: "8 - Photocopy service / ร้านถ่ายเอกสาร", value: 8 },
    { text: "9 - Reading area / ที่นั่งอ่านหนังสือแบบเดี่ยว", value: 9 },
    { text: "10 - Reading area / ที่นั่งอ่านหนังสือแบบเดี่ยว", value: 10 },
    { text: "11 - U2 level stairway / บันไดชั้น U2", value: 11 },
    {
      text:
        "12 - Thai language general books, U2 level / หนังสือภาษาไทย ชั้น U2",
      value: 12
    },
    {
      text:
        "13 - Thai language general books, U2 level / หนังสือภาษาไทย ชั้น U2",
      value: 13
    },
    {
      text:
        "14 - Thai language general books, U2 level / หนังสือภาษาไทย ชั้น U2",
      value: 14
    },
    {
      text: "15 - Online public access catalog / คอมพิวเตอร์สืบค้นหนังสือ",
      value: 15
    },
    { text: "16 - Fiction / หนังสือนิยาย", value: 16 },
    {
      text: "17 - Thailand Research Fund publications / งานวิจัย สกว. TRF",
      value: 17
    },
    { text: "18 - U2 level stairway / บันไดชั้น U2", value: 18 },
    { text: "19 - U2 level stairway / บันไดชั้น U2", value: 19 },
    {
      text:
        "20 - Adul Wichiencharoen Room / ห้องศาสตราจารย์ ดร.อดุลย์ วิเชียรเจริญ",
      value: 20
    },
    { text: "21 - U3 level stairway / บันไดชั้น U3", value: 21 },
    {
      text:
        "22 - Thai language general books, U3 level / หนังสือภาษาไทย ชั้น U3",
      value: 22
    },
    {
      text:
        "23 - Thai language general books, U3 level / หนังสือภาษาไทย ชั้น U3",
      value: 23
    },
    {
      text:
        "24 - Thai language general books, U3 level / หนังสือภาษาไทย ชั้น U3",
      value: 24
    },
    {
      text:
        "25 - Thai language general books, U3 level / หนังสือภาษาไทย ชั้น U3",
      value: 25
    },
    {
      text:
        "26 - Thai language general books, U3 level / หนังสือภาษาไทย ชั้น U3",
      value: 26
    },
    {
      text:
        "27 - Thai language general books, U3 level / หนังสือภาษาไทย ชั้น U3",
      value: 27
    },
    {
      text: "28 - Foreign language general books / หนังสือภาษาอังกฤษ",
      value: 28
    },
    {
      text: "29 - Foreign language general books / หนังสือภาษาอังกฤษ",
      value: 29
    },
    {
      text: "30 - Foreign language general books / หนังสือภาษาอังกฤษ",
      value: 30
    }
  ],
  codes: {
    EN1: { category: "General Stacks", first: "A", second: "" },
    EN2: { category: "General Stacks", first: "B187", second: "" },
    EN3: { category: "General Stacks", first: "B829.5", second: "" },
    EN4: { category: "General Stacks", first: "B2760", second: "" },
    EN5: { category: "General Stacks", first: "BC70", second: "" },
    EN6: { category: "General Stacks", first: "BF109", second: "F74" },
    EN7: { category: "General Stacks", first: "BF455", second: "S" },
    EN8: { category: "General Stacks", first: "BF713", second: "S3" },
    EN9: { category: "General Stacks", first: "BL60", second: "M" },
    EN10: { category: "General Stacks", first: "BP161.2", second: "" },
    EN11: { category: "General Stacks", first: "BQ7600", second: "" },
    EN12: { category: "General Stacks", first: "CB83", second: "" },
    EN13: { category: "General Stacks", first: "D220", second: "" },
    EN14: { category: "General Stacks", first: "D804.6", second: "" },
    EN15: { category: "General Stacks", first: "DA566.9", second: "G" },
    EN16: { category: "General Stacks", first: "DG311", second: "G" },
    EN17: { category: "General Stacks", first: "DS63.2", second: "U" },
    EN18: { category: "General Stacks", first: "DS423", second: "N" },
    EN19: { category: "General Stacks", first: "DS527.9", second: "" },
    EN20: { category: "General Stacks", first: "DS571", second: "L" },
    EN21: { category: "General Stacks", first: "DS730", second: "" },
    EN22: { category: "General Stacks", first: "DS835", second: "T" },
    EN23: { category: "General Stacks", first: "E178.3", second: "" },
    EN24: { category: "General Stacks", first: "E886", second: "" },
    EN25: { category: "General Stacks", first: "GE100", second: "" },
    EN26: { category: "General Stacks", first: "GN406", second: "" },
    EN27: { category: "General Stacks", first: "GV75", second: "" },
    EN28: { category: "General Stacks", first: "HA29", second: "U" },
    EN29: { category: "General Stacks", first: "HC51", second: "M" },
    EN30: { category: "General Stacks", first: "HC428", second: "" },
    EN31: { category: "General Stacks", first: "HD30.42", second: "" },
    EN32: { category: "General Stacks", first: "HD58.9", second: "G" },
    EN33: { category: "General Stacks", first: "HD2346", second: "M" },
    EN34: { category: "General Stacks", first: "HD8080", second: "" },
    EN35: { category: "General Stacks", first: "HF1359", second: "P" },
    EN36: { category: "General Stacks", first: "HF5415.13", second: "S" },
    EN37: { category: "General Stacks", first: "HF5549.5", second: "T" },
    EN38: { category: "General Stacks", first: "HG221", second: "" },
    EN39: { category: "General Stacks", first: "HG4550", second: "" },
    EN40: { category: "General Stacks", first: "HM101", second: "S8" },
    EN41: { category: "General Stacks", first: "HM820", second: "" },
    EN42: { category: "General Stacks", first: "HN980", second: "I" },
    EN43: { category: "General Stacks", first: "HQ767.9", second: "" },
    EN44: { category: "General Stacks", first: "HQ1237", second: "" },
    EN45: { category: "General Stacks", first: "HV11", second: "O" },
    EN46: { category: "General Stacks", first: "HV888", second: "" },
    EN47: { category: "General Stacks", first: "HV6568", second: "" },
    EN48: { category: "General Stacks", first: "I", second: "" },
    EN49: { category: "General Stacks", first: "JC337", second: "" },
    EN50: { category: "General Stacks", first: "JF300", second: "" },
    EN51: { category: "General Stacks", first: "JN94", second: "A9" },
    EN52: { category: "General Stacks", first: "JQ1850", second: "" },
    EN53: { category: "General Stacks", first: "JX3180", second: "" },
    EN54: { category: "General Stacks", first: "K1401", second: "D" },
    EN55: { category: "General Stacks", first: "KF658", second: "" },
    EN56: { category: "General Stacks", first: "KQ", second: "" },
    EN57: { category: "General Stacks", first: "LB1050", second: "D" },
    EN58: { category: "General Stacks", first: "LB2342.1", second: "" },
    EN59: { category: "General Stacks", first: "LC3731", second: "F" },
    EN60: { category: "General Stacks", first: "ML650", second: "" },
    EN61: { category: "General Stacks", first: "N5343", second: "" },
    EN62: { category: "General Stacks", first: "NA1526", second: "" },
    EN63: { category: "General Stacks", first: "ND1133", second: "" },
    EN64: { category: "General Stacks", first: "P40", second: "S" },
    EN65: { category: "General Stacks", first: "P96", second: "T42" },
    EN66: { category: "General Stacks", first: "P211", second: "W" },
    EN67: { category: "General Stacks", first: "PC2075", second: "" },
    EN68: { category: "General Stacks", first: "PE1115", second: "N" },
    EN69: { category: "General Stacks", first: "PE1128", second: "S7" },
    EN70: { category: "General Stacks", first: "PE1582", second: "" },
    EN71: { category: "General Stacks", first: "PL537", second: "" },
    EN72: { category: "General Stacks", first: "PL3503", second: "" },
    EN73: { category: "General Stacks", first: "PN94", second: "G" },
    EN74: { category: "General Stacks", first: "PN1998", second: "" },
    EN75: { category: "General Stacks", first: "PN5176", second: "" },
    EN76: { category: "General Stacks", first: "PQ2599", second: "" },
    EN77: { category: "General Stacks", first: "PR509", second: "" },
    EN78: { category: "General Stacks", first: "PR2248", second: "" },
    EN79: { category: "General Stacks", first: "PR3592", second: "" },
    EN80: { category: "General Stacks", first: "PR5892", second: "" },
    EN81: { category: "General Stacks", first: "PS62", second: "" },
    EN82: { category: "General Stacks", first: "PS1606", second: "" },
    EN83: { category: "General Stacks", first: "PS3536", second: "" },
    EN84: { category: "General Stacks", first: "PZ7", second: "D" },
    EN85: { category: "General Stacks", first: "Q175", second: "R" },
    EN86: { category: "General Stacks", first: "QA76.8", second: "" },
    EN87: { category: "General Stacks", first: "QC981.1", second: "" },
    EN88: { category: "General Stacks", first: "RA425", second: "" },
    EN89: { category: "General Stacks", first: "T58.64", second: "I" },
    EN90: { category: "General Stacks", first: "TK5105.8883", second: "" },
    EN91: { category: "General Stacks", first: "TT705", second: "" },
    EN92: { category: "General Stacks", first: "U602", second: "" },
    EN93: { category: "General Stacks", first: "WD1", second: "" },
    EN94: { category: "General Stacks", first: "WQ", second: "" },
    EN95: { category: "General Stacks", first: "Z675", second: "E" },
    EN96: { category: "General Stacks", first: "Z695.7", second: "" },
    SP1: { category: "Adul Wichiencharoen Room", first: "", second: "" },
    SP2: { category: "Charnvit Kasetsiri Room", first: "", second: "" },
    SP3: { category: "Circulation Counter", first: "", second: "" },
    SP4: { category: "Fiction Stacks", first: "", second: "" },
    SP5: { category: "India Corner", first: "", second: "" },
    SP6: { category: "Pakistan Corner", first: "", second: "" },
    SP7: { category: "Puey Ungphakorn Corner", first: "", second: "" },
    SP8: { category: "Reference Stacks", first: "", second: "" },
    SP9: { category: "Rewat Buddhinan Music Room", first: "", second: "" },
    SP10: { category: "Special Collection Room 2", first: "", second: "" },
    SP11: {
      category: "Special Collection Room 2: Shaiwatna Kupratakuln",
      first: "",
      second: ""
    },
    SP12: { category: "TRF Publications Corner", first: "", second: "" },
    SP13: {
      category: "Educational Media Service Center",
      first: "",
      second: ""
    },
    TH1: { category: "General Stacks", first: "", second: "" },
    TH2: { category: "General Stacks", first: "BF1", second: "" },
    TH3: { category: "General Stacks", first: "BF632", second: "" },
    TH4: { category: "General Stacks", first: "BF698", second: "ป" },
    TH5: { category: "General Stacks", first: "BJ1481", second: "" },
    TH6: { category: "General Stacks", first: "BL1411", second: "ช6พ" },
    TH7: { category: "General Stacks", first: "BQ924", second: "บ" },
    TH8: { category: "General Stacks", first: "BQ2623", second: "" },
    TH9: { category: "General Stacks", first: "BQ4506", second: "ต9ส" },
    TH10: { category: "General Stacks", first: "BQ5275", second: "ท92" },
    TH11: { category: "General Stacks", first: "BQ5845", second: "" },
    TH12: { category: "General Stacks", first: "BT877", second: "" },
    TH13: { category: "General Stacks", first: "CT1548", second: "ก7" },
    TH14: { category: "General Stacks", first: "CT3699", second: "" },
    TH15: { category: "General Stacks", first: "D805", second: "" },
    TH16: { category: "General Stacks", first: "DK290", second: "" },
    TH17: { category: "General Stacks", first: "DS486", second: "" },
    TH18: { category: "General Stacks", first: "DS528.5", second: "" },
    TH19: { category: "General Stacks", first: "DS557", second: "ก66" },
    TH20: { category: "General Stacks", first: "DS567", second: "ศ6" },
    TH21: { category: "General Stacks", first: "DS568.3", second: "ด" },
    TH22: { category: "General Stacks", first: "DS570.3", second: "จ7ก6" },
    TH23: { category: "General Stacks", first: "DS570.3", second: "ภ7ว" },
    TH24: { category: "General Stacks", first: "DS570.5", second: "ส4" },
    TH25: { category: "General Stacks", first: "DS570.6", second: "ป46ส7" },
    TH26: { category: "General Stacks", first: "DS571", second: "น" },
    TH27: { category: "General Stacks", first: "DS575.5", second: "ญ" },
    TH28: { category: "General Stacks", first: "DS578.32", second: "" },
    TH29: { category: "General Stacks", first: "DS582.5", second: "ส5" },
    TH30: { category: "General Stacks", first: "DS586", second: "ร" },
    TH31: { category: "General Stacks", first: "DS589", second: "ก4จ" },
    TH32: { category: "General Stacks", first: "DS589", second: "พ2ป" },
    TH33: { category: "General Stacks", first: "DS620.2", second: "" },
    TH34: { category: "General Stacks", first: "DS777", second: "" },
    TH35: { category: "General Stacks", first: "DS885", second: "" },
    TH36: { category: "General Stacks", first: "F2000", second: "" },
    TH37: { category: "General Stacks", first: "GB55", second: "ว" },
    TH38: { category: "General Stacks", first: "GN316", second: "" },
    TH39: { category: "General Stacks", first: "GT3278", second: "ก2พ" },
    TH40: { category: "General Stacks", first: "GV1130", second: "" },
    TH41: { category: "General Stacks", first: "H62.5", second: "น" },
    TH42: { category: "General Stacks", first: "HA40", second: "ล" },
    TH43: { category: "General Stacks", first: "HB180", second: "ส66" },
    TH44: { category: "General Stacks", first: "HC79", second: "ร" },
    TH45: { category: "General Stacks", first: "HC445", second: "ว68" },
    TH46: { category: "General Stacks", first: "HC462", second: "" },
    TH47: { category: "General Stacks", first: "HD30.28", second: "ค83" },
    TH48: { category: "General Stacks", first: "HD31", second: "อ" },
    TH49: { category: "General Stacks", first: "HD37", second: "อ684" },
    TH50: { category: "General Stacks", first: "HD51", second: "" },
    TH51: { category: "General Stacks", first: "HD58.9", second: "ก" },
    TH52: { category: "General Stacks", first: "HD62.7", second: "ภ" },
    TH53: { category: "General Stacks", first: "HD85", second: "ส74" },
    TH54: { category: "General Stacks", first: "HD1390", second: "" },
    TH55: { category: "General Stacks", first: "HD2080.55", second: "ฮ8ร" },
    TH56: { category: "General Stacks", first: "HD4325", second: "" },
    TH57: { category: "General Stacks", first: "HD6483", second: "ห" },
    TH58: { category: "General Stacks", first: "HD9000.5", second: "ฟ" },
    TH59: { category: "General Stacks", first: "HD9696", second: "ข" },
    TH60: { category: "General Stacks", first: "HE8390.55", second: "ล" },
    TH61: { category: "General Stacks", first: "HF1382.6", second: "ซ7ศ" },
    TH62: { category: "General Stacks", first: "HF1383", second: "" },
    TH63: { category: "General Stacks", first: "HF5383", second: "ป" },
    TH64: { category: "General Stacks", first: "HF5415", second: "อ" },
    TH65: { category: "General Stacks", first: "HF5415.55", second: "" },
    TH66: { category: "General Stacks", first: "HF5548.32", second: "น" },
    TH67: { category: "General Stacks", first: "HF5549", second: "ป44" },
    TH68: { category: "General Stacks", first: "HF5549.5", second: "ง62" },
    TH69: { category: "General Stacks", first: "HF5550", second: "" },
    TH70: { category: "General Stacks", first: "HF5655", second: "ว" },
    TH71: { category: "General Stacks", first: "HF5679", second: "ร" },
    TH72: { category: "General Stacks", first: "HF5686", second: "ห" },
    TH73: { category: "General Stacks", first: "HF5821", second: "ม" },
    TH74: { category: "General Stacks", first: "", second: "" },
    TH75: { category: "General Stacks", first: "", second: "" },
    TH76: { category: "General Stacks", first: "", second: "" },
    TH77: { category: "General Stacks", first: "HG1", second: "" },
    TH78: { category: "General Stacks", first: "HG1619", second: "" },
    TH79: { category: "General Stacks", first: "HG3769", second: "" },
    TH80: { category: "General Stacks", first: "HG4529", second: "ญ" },
    TH81: { category: "General Stacks", first: "HG6041", second: "ด" },
    TH82: { category: "General Stacks", first: "HJ2330", second: "" },
    TH83: { category: "General Stacks", first: "HJ7000", second: "" },
    TH84: { category: "General Stacks", first: "HM132", second: "อ" },
    TH85: { category: "General Stacks", first: "HM263", second: "ส75" },
    TH86: { category: "General Stacks", first: "HN59", second: "" },
    TH87: { category: "General Stacks", first: "HN700.575", second: "ธ" },
    TH88: { category: "General Stacks", first: "HN700.592", second: "พ6ส5" },
    TH89: { category: "General Stacks", first: "HQ56", second: "ษ" },
    TH90: { category: "General Stacks", first: "HQ769", second: "ก5" },
    TH91: { category: "General Stacks", first: "HQ1063", second: "" },
    TH92: { category: "General Stacks", first: "HT391", second: "" },
    TH93: { category: "General Stacks", first: "HV692", second: "" },
    TH94: { category: "General Stacks", first: "HV5600.57", second: "" },
    TH95: { category: "General Stacks", first: "HV6626.23", second: "ท9ว7" },
    TH96: { category: "General Stacks", first: "HV8200", second: "" },
    TH97: { category: "General Stacks", first: "HV9800.55", second: "บ" },
    TH98: { category: "General Stacks", first: "JA71", second: "ส50" },
    TH99: { category: "General Stacks", first: "JF700", second: "" },
    TH100: { category: "General Stacks", first: "JQ1631", second: "จ" },
    TH101: { category: "General Stacks", first: "JQ1745", second: "ก5" },
    TH102: { category: "General Stacks", first: "JQ1745", second: "บ" },
    TH103: { category: "General Stacks", first: "JQ1746", second: "ฮ13จ5" },
    TH104: { category: "General Stacks", first: "JQ1748", second: "ถ" },
    TH105: { category: "General Stacks", first: "JS7153.3", second: "ก3" },
    TH106: { category: "General Stacks", first: "JX1900", second: "" },
    TH107: { category: "General Stacks", first: "K800", second: "" },
    TH108: { category: "General Stacks", first: "K5000", second: "" },
    TH109: { category: "General Stacks", first: "KPT72", second: "ป" },
    TH110: { category: "General Stacks", first: "KPT770", second: "พ" },
    TH111: { category: "General Stacks", first: "KPT1150", second: "" },
    TH112: { category: "General Stacks", first: "KPT1650", second: "" },
    TH113: { category: "General Stacks", first: "KPT2068", second: "" },
    TH114: { category: "General Stacks", first: "KPT2735", second: "บ" },
    TH115: { category: "General Stacks", first: "KPT3400", second: "" },
    TH116: { category: "General Stacks", first: "KPT3800", second: "ส450" },
    TH117: { category: "General Stacks", first: "L1", second: "" },
    TH118: { category: "General Stacks", first: "LA2380", second: "" },
    TH119: { category: "General Stacks", first: "LB1028.5", second: "" },
    TH120: { category: "General Stacks", first: "LB1567", second: "" },
    TH121: { category: "General Stacks", first: "LB2349", second: "ม" },
    TH122: { category: "General Stacks", first: "LB2845", second: "" },
    TH123: { category: "General Stacks", first: "LC190", second: "" },
    TH124: { category: "General Stacks", first: "LG395", second: "ก231ส7" },
    TH125: { category: "General Stacks", first: "M1824", second: "ภ" },
    TH126: { category: "General Stacks", first: "MT1", second: "" },
    TH127: { category: "General Stacks", first: "N7470", second: "" },
    TH128: { category: "General Stacks", first: "NA6022", second: "ช" },
    TH129: { category: "General Stacks", first: "ND600", second: "" },
    TH130: { category: "General Stacks", first: "NK9000", second: "" },
    TH131: { category: "General Stacks", first: "P96", second: "ก5" },
    TH132: { category: "General Stacks", first: "PE1068", second: "ท9" },
    TH133: { category: "General Stacks", first: "PE1131", second: "จ" },
    TH134: { category: "General Stacks", first: "PE1460", second: "ว" },
    TH135: { category: "General Stacks", first: "PJ1", second: "" },
    TH136: { category: "General Stacks", first: "PL1121", second: "น" },
    TH137: { category: "General Stacks", first: "PL3275", second: "บ" },
    TH138: { category: "General Stacks", first: "PL4164", second: "" },
    TH139: { category: "General Stacks", first: "PL4200", second: "ม" },
    TH140: { category: "General Stacks", first: "PL4203", second: "" },
    TH141: { category: "General Stacks", first: "PL4209", second: "จ5" },
    TH142: { category: "General Stacks", first: "PL4209", second: "พ16" },
    TH143: { category: "General Stacks", first: "PL4209", second: "ส724" },
    TH144: { category: "General Stacks", first: "PL4209.2", second: "ม" },
    TH145: { category: "General Stacks", first: "PN1", second: "" },
    TH146: { category: "General Stacks", first: "PN1992.77", second: "ว" },
    TH147: { category: "General Stacks", first: "PN4229", second: "น6" },
    TH148: { category: "General Stacks", first: "PN6081", second: "" },
    TH149: { category: "General Stacks", first: "PS120", second: "" },
    TH150: { category: "General Stacks", first: "QA1", second: "" },
    TH151: { category: "General Stacks", first: "QH193", second: "ท9ส" },
    TH152: { category: "General Stacks", first: "QV770", second: "JT3พ" },
    TH153: { category: "General Stacks", first: "SK", second: "" },
    TH154: { category: "General Stacks", first: "TD745", second: "" },
    TH155: { category: "General Stacks", first: "TL226", second: "" },
    TH156: { category: "General Stacks", first: "TS156", second: "" },
    TH157: { category: "General Stacks", first: "TT958", second: "" },
    TH158: { category: "General Stacks", first: "TX773", second: "ส" },
    TH159: { category: "General Stacks", first: "UB1", second: "" },
    TH160: { category: "General Stacks", first: "W540", second: "JTร54" },
    TH161: { category: "General Stacks", first: "WC503.6", second: "ผ" },
    TH162: { category: "General Stacks", first: "WM440", second: "" },
    TH163: { category: "General Stacks", first: "WZ100", second: "ส75" },
    TH164: { category: "General Stacks", first: "Z688", second: "" },
  },
  floors: ["U1", "U2", "U3"],
  name: "Pridi Banomyong Library",
  nodes: {
    CP1: { floor: "U1", from: ["CP2"], x: 855, y: 630 },
    CP2: { floor: "U1", from: ["CP1", "CP3", "CP8"], x: 855, y: 500 },
    CP3: { floor: "U1", from: ["CP2", "CP4", "CP5"], x: 661, y: 540 },
    CP4: { floor: "U1", from: ["CP3", "CP11"], x: 712, y: 550 },
    CP5: { floor: "U1", from: ["CP3", "CP6"], x: 498, y: 506 },
    CP6: { floor: "U1", from: ["CP5", "CP7"], x: 389, y: 485 },
    CP7: { floor: "U1", from: ["CP6"], x: 281, y: 462 },
    CP8: { floor: "U1", from: ["CP2", "CP9"], x: 855, y: 345 },
    CP9: { floor: "U1", from: ["CP8", "CP10"], x: 726, y: 345 },
    CP10: { floor: "U1", from: ["CP9"], x: 596, y: 345 },
    CP11: { floor: "U2", from: ["CP4", "CP12"], x: 827, y: 578 },
    CP12: {
      floor: "U2",
      from: ["CP11", "CP13", "CP15", "CP18"],
      x: 886,
      y: 578
    },
    CP13: { floor: "U2", from: ["CP12", "CP14"], x: 886, y: 470 },
    CP14: { floor: "U2", from: ["CP13"], x: 886, y: 343 },
    CP15: { floor: "U2", from: ["CP12", "CP16"], x: 886, y: 855 },
    CP16: { floor: "U2", from: ["CP15", "CP17"], x: 886, y: 966 },
    CP17: { floor: "U2", from: ["CP16"], x: 752, y: 966 },
    CP18: { floor: "U2", from: ["CP12", "CP19"], x: 734, y: 624 },
    CP19: { floor: "U2", from: ["CP18", "CP20", "CP21"], x: 748, y: 578 },
    CP20: { floor: "U2", from: ["CP19"], x: 506, y: 538 },
    CP21: { floor: "U3", from: ["CP19", "CP22"], x: 827, y: 577 },
    CP22: { floor: "U3", from: ["CP21", "CP25", "CP31"], x: 887, y: 577 },
    CP23: { floor: "U3", from: ["CP24", "CP31"], x: 887, y: 707 },
    CP24: { floor: "U3", from: ["CP23"], x: 887, y: 880 },
    CP25: { floor: "U3", from: ["CP22", "CP26"], x: 887, y: 470 },
    CP26: { floor: "U3", from: ["CP25", "CP27", "CP35"], x: 887, y: 320 },
    CP27: { floor: "U3", from: ["CP26", "CP28"], x: 887, y: 234 },
    CP28: { floor: "U3", from: ["CP27", "CP29"], x: 751, y: 234 },
    CP29: { floor: "U3", from: ["CP28", "CP30"], x: 637, y: 234 },
    CP30: { floor: "U3", from: ["CP29"], x: 523, y: 234 },
    CP31: { floor: "U3", from: ["CP22", "CP23", "CP32"], x: 887, y: 613 },
    CP32: { floor: "U3", from: ["CP31", "CP33", "CP34"], x: 737, y: 613 },
    CP33: { floor: "U3", from: ["CP32"], x: 737, y: 880 },
    CP34: { floor: "U3", from: ["CP32"], x: 643, y: 613 },
    CP35: { floor: "U3", from: ["CP26", "CP36"], x: 510, y: 320 },
    CP36: { floor: "U3", from: ["CP35"], x: 510, y: 400 },
    EN1: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 406,
      y: 234
    },
    EN2: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 406,
      y: 234
    },
    EN3: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 425,
      y: 234
    },
    EN4: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 425,
      y: 234
    },
    EN5: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 444,
      y: 234
    },
    EN6: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 444,
      y: 234
    },
    EN7: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 463,
      y: 234
    },
    EN8: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 463,
      y: 234
    },
    EN9: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 482,
      y: 234
    },
    EN10: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 482,
      y: 234
    },
    EN11: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 501,
      y: 234
    },
    EN12: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 501,
      y: 234
    },
    EN13: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 520,
      y: 234
    },
    EN14: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 520,
      y: 234
    },
    EN15: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 539,
      y: 234
    },
    EN16: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 539,
      y: 234
    },
    EN17: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 558,
      y: 234
    },
    EN18: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 558,
      y: 234
    },
    EN19: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 577,
      y: 234
    },
    EN20: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 577,
      y: 234
    },
    EN21: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 596,
      y: 234
    },
    EN22: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 596,
      y: 234
    },
    EN23: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 615,
      y: 234
    },
    EN24: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 615,
      y: 234
    },
    EN25: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 634,
      y: 234
    },
    EN26: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 634,
      y: 234
    },
    EN27: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 653,
      y: 234
    },
    EN28: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 653,
      y: 234
    },
    EN29: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 672,
      y: 234
    },
    EN30: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 672,
      y: 234
    },
    EN31: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 691,
      y: 234
    },
    EN32: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 691,
      y: 234
    },
    EN33: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 710,
      y: 234
    },
    EN34: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 710,
      y: 234
    },
    EN35: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 729,
      y: 234
    },
    EN36: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 729,
      y: 234
    },
    EN37: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 748,
      y: 234
    },
    EN38: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 748,
      y: 234
    },
    EN39: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 767,
      y: 234
    },
    EN40: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 767,
      y: 234
    },
    EN41: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 786,
      y: 234
    },
    EN42: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 786,
      y: 234
    },
    EN43: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 805,
      y: 234
    },
    EN44: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 805,
      y: 234
    },
    EN45: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 824,
      y: 234
    },
    EN46: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 824,
      y: 234
    },
    EN47: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 843,
      y: 234
    },
    EN48: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 843,
      y: 234
    },
    EN49: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 425,
      y: 234
    },
    EN50: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 425,
      y: 234
    },
    EN51: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 444,
      y: 234
    },
    EN52: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 444,
      y: 234
    },
    EN53: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 463,
      y: 234
    },
    EN54: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 463,
      y: 234
    },
    EN55: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 482,
      y: 234
    },
    EN56: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 482,
      y: 234
    },
    EN57: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 501,
      y: 234
    },
    EN58: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 501,
      y: 234
    },
    EN59: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 520,
      y: 234
    },
    EN60: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 520,
      y: 234
    },
    EN61: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 539,
      y: 234
    },
    EN62: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 539,
      y: 234
    },
    EN63: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 558,
      y: 234
    },
    EN64: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 558,
      y: 234
    },
    EN65: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 577,
      y: 234
    },
    EN66: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 577,
      y: 234
    },
    EN67: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 596,
      y: 234
    },
    EN68: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 596,
      y: 234
    },
    EN69: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 615,
      y: 234
    },
    EN70: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 615,
      y: 234
    },
    EN71: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 634,
      y: 234
    },
    EN72: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 634,
      y: 234
    },
    EN73: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 653,
      y: 234
    },
    EN74: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 653,
      y: 234
    },
    EN75: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 672,
      y: 234
    },
    EN76: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 672,
      y: 234
    },
    EN77: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 691,
      y: 234
    },
    EN78: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 691,
      y: 234
    },
    EN79: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 710,
      y: 234
    },
    EN80: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 710,
      y: 234
    },
    EN81: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 729,
      y: 234
    },
    EN82: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 729,
      y: 234
    },
    EN83: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 748,
      y: 234
    },
    EN84: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 748,
      y: 234
    },
    EN85: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 767,
      y: 234
    },
    EN86: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 767,
      y: 234
    },
    EN87: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 786,
      y: 234
    },
    EN88: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 786,
      y: 234
    },
    EN89: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 805,
      y: 234
    },
    EN90: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 805,
      y: 234
    },
    EN91: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 824,
      y: 234
    },
    EN92: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 824,
      y: 234
    },
    EN93: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 843,
      y: 234
    },
    EN94: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 843,
      y: 234
    },
    EN95: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 862,
      y: 234
    },
    EN96: {
      floor: "U3",
      from: ["CP27", "CP28", "CP29", "CP30"],
      x: 862,
      y: 234
    },
    SP1: { floor: "U2", from: ["CP17"], x: 643, y: 966 },
    SP2: { floor: "U1", from: ["CP9"], x: 726, y: 213 },
    SP3: { floor: "U1", from: ["CP1"], x: 791, y: 886 },
    SP4: { floor: "U2", from: ["CP16"], x: 886, y: 966 },
    SP5: { floor: "U1", from: ["CP5"], x: 498, y: 506 },
    SP6: { floor: "U1", from: ["CP6"], x: 389, y: 485 },
    SP7: { floor: "U1", from: ["CP7"], x: 213, y: 462 },
    SP8: { floor: "U3", from: ["CP24"], x: 766, y: 880 },
    SP9: { floor: "U2", from: ["CP20"], x: 506, y: 223 },
    SP10: { floor: "U1", from: ["CP10"], x: 596, y: 213 },
    SP11: { floor: "U1", from: ["CP10"], x: 596, y: 213 },
    SP12: { floor: "U2", from: ["CP17"], x: 699, y: 966 },
    SP13: { floor: "U2", from: ["SP9"], x: 411, y: 261 },
    TH1: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 625
    },
    TH2: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 625
    },
    TH3: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 642
    },
    TH4: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 642
    },
    TH5: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 660
    },
    TH6: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 660
    },
    TH7: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 677
    },
    TH8: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 677
    },
    TH9: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 695
    },
    TH10: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 695
    },
    TH11: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 712
    },
    TH12: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 712
    },
    TH13: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 625
    },
    TH14: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 625
    },
    TH15: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 643
    },
    TH16: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 643
    },
    TH17: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 660
    },
    TH18: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 660
    },
    TH19: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 678
    },
    TH20: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 678
    },
    TH21: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 695
    },
    TH22: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 695
    },
    TH23: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 713
    },
    TH24: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 713
    },
    TH25: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 730
    },
    TH26: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 730
    },
    TH27: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 748
    },
    TH28: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 748
    },
    TH29: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 765
    },
    TH30: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 765
    },
    TH31: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 783
    },
    TH32: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 783
    },
    TH33: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 800
    },
    TH34: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 800
    },
    TH35: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 818
    },
    TH36: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 818
    },
    TH37: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 835
    },
    TH38: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 835
    },
    TH39: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 852
    },
    TH40: {
      floor: "U3",
      from: ["CP32", "CP33"],
      x: 737,
      y: 852
    },
    TH41: {
      floor: "U3",
      from: ["CP34"],
      x: 643,
      y: 625
    },
    TH42: {
      floor: "U3",
      from: ["CP34"],
      x: 643,
      y: 625
    },
    TH43: {
      floor: "U3",
      from: ["CP34"],
      x: 643,
      y: 642
    },
    TH44: {
      floor: "U3",
      from: ["CP34"],
      x: 643,
      y: 642
    },
    TH45: {
      floor: "U3",
      from: ["CP34"],
      x: 643,
      y: 660
    },
    TH46: {
      floor: "U3",
      from: ["CP34"],
      x: 643,
      y: 660
    },
    TH47: {
      floor: "U3",
      from: ["CP34"],
      x: 643,
      y: 677
    },
    TH48: {
      floor: "U3",
      from: ["CP34"],
      x: 643,
      y: 677
    },
    TH49: {
      floor: "U3",
      from: ["CP34"],
      x: 643,
      y: 695
    },
    TH50: {
      floor: "U3",
      from: ["CP34"],
      x: 643,
      y: 695
    },
    TH51: {
      floor: "U3",
      from: ["CP34"],
      x: 643,
      y: 712
    },
    TH52: {
      floor: "U3",
      from: ["CP34"],
      x: 643,
      y: 712
    },
    TH53: {
      floor: "U3",
      from: ["CP34"],
      x: 643,
      y: 730
    },
    TH54: {
      floor: "U3",
      from: ["CP34"],
      x: 643,
      y: 730
    },
    TH55: {
      floor: "U3",
      from: ["CP34"],
      x: 643,
      y: 747
    },
    TH56: {
      floor: "U3",
      from: ["CP34"],
      x: 643,
      y: 747
    },
    TH57: {
      floor: "U3",
      from: ["CP36"],
      x: 500,
      y: 400
    },
    TH58: {
      floor: "U3",
      from: ["CP36"],
      x: 500,
      y: 400
    },
    TH59: {
      floor: "U3",
      from: ["CP36"],
      x: 481,
      y: 400
    },
    TH60: {
      floor: "U3",
      from: ["CP36"],
      x: 481,
      y: 400
    },
    TH61: {
      floor: "U3",
      from: ["CP36"],
      x: 462,
      y: 400
    },
    TH62: {
      floor: "U3",
      from: ["CP36"],
      x: 462,
      y: 400
    },
    TH63: {
      floor: "U3",
      from: ["CP36"],
      x: 444,
      y: 400
    },
    TH64: {
      floor: "U3",
      from: ["CP36"],
      x: 444,
      y: 400
    },
    TH65: {
      floor: "U3",
      from: ["CP36"],
      x: 425,
      y: 400
    },
    TH66: {
      floor: "U3",
      from: ["CP36"],
      x: 425,
      y: 400
    },
    TH67: {
      floor: "U3",
      from: ["CP36"],
      x: 500,
      y: 400
    },
    TH68: {
      floor: "U3",
      from: ["CP36"],
      x: 500,
      y: 400
    },
    TH69: {
      floor: "U3",
      from: ["CP36"],
      x: 481,
      y: 400
    },
    TH70: {
      floor: "U3",
      from: ["CP36"],
      x: 481,
      y: 400
    },
    TH71: {
      floor: "U3",
      from: ["CP36"],
      x: 462,
      y: 400
    },
    TH72: {
      floor: "U3",
      from: ["CP36"],
      x: 462,
      y: 400
    },
    TH73: {
      floor: "U3",
      from: ["CP36"],
      x: 444,
      y: 400
    },
    TH74: {
      floor: "U3",
      from: ["CP36"],
      x: 444,
      y: 400
    },
    TH75: {
      floor: "U3",
      from: ["CP36"],
      x: 425,
      y: 400
    },
    TH76: {
      floor: "U3",
      from: ["CP36"],
      x: 425,
      y: 400
    },
    TH77: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 209
    },
    TH78: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 209
    },
    TH79: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 228
    },
    TH80: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 228
    },
    TH81: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 246
    },
    TH82: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 246
    },
    TH83: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 265
    },
    TH84: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 265
    },
    TH85: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 283
    },
    TH86: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 283
    },
    TH87: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 302
    },
    TH88: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 302
    },
    TH89: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 320
    },
    TH90: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 320
    },
    TH91: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 339
    },
    TH92: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 339
    },
    TH93: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 357
    },
    TH94: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 357
    },
    TH95: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 376
    },
    TH96: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 376
    },
    TH97: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 394
    },
    TH98: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 394
    },
    TH99: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 413
    },
    TH100: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 413
    },
    TH101: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 431
    },
    TH102: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 431
    },
    TH103: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 450
    },
    TH104: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 450
    },
    TH105: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 468
    },
    TH106: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 468
    },
    TH107: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 487
    },
    TH108: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 487
    },
    TH109: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 505
    },
    TH110: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 505
    },
    TH111: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 524
    },
    TH112: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 524
    },
    TH113: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 542
    },
    TH114: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 542
    },
    TH115: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 561
    },
    TH116: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 561
    },
    TH117: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 579
    },
    TH118: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 579
    },
    TH119: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 598
    },
    TH120: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 598
    },
    TH121: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 616
    },
    TH122: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 616
    },
    TH123: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 635
    },
    TH124: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 635
    },
    TH125: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 653
    },
    TH126: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 653
    },
    TH127: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 672
    },
    TH128: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 672
    },
    TH129: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 690
    },
    TH130: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 690
    },
    TH131: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 709
    },
    TH132: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 709
    },
    TH133: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 727
    },
    TH134: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 727
    },
    TH135: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 746
    },
    TH136: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 746
    },
    TH137: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 764
    },
    TH138: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 764
    },
    TH139: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 783
    },
    TH140: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 783
    },
    TH141: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 801
    },
    TH142: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 801
    },
    TH143: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 820
    },
    TH144: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 820
    },
    TH145: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 838
    },
    TH146: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 838
    },
    TH147: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 857
    },
    TH148: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 857
    },
    TH149: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 875
    },
    TH150: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 875
    },
    TH151: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 894
    },
    TH152: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 894
    },
    TH153: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 912
    },
    TH154: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 912
    },
    TH155: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 931
    },
    TH156: {
      floor: "U3",
      from: ["CP22", "CP23", "CP24", "CP25", "CP26", "CP27", "CP31"],
      x: 887,
      y: 931
    },
    TH157: {
      floor: "U3",
      from: ["CP24", "CP33"],
      x: 867,
      y: 880
    },
    TH158: {
      floor: "U3",
      from: ["CP24", "CP33"],
      x: 867,
      y: 880
    },
    TH159: {
      floor: "U3",
      from: ["CP24", "CP33"],
      x: 847,
      y: 880
    },
    TH160: {
      floor: "U3",
      from: ["CP24", "CP33"],
      x: 847,
      y: 880
    },
    TH161: {
      floor: "U3",
      from: ["CP24", "CP33"],
      x: 827,
      y: 880
    },
    TH162: {
      floor: "U3",
      from: ["CP24", "CP33"],
      x: 827,
      y: 880
    },
    TH163: {
      floor: "U3",
      from: ["CP24", "CP33"],
      x: 807,
      y: 880
    },
    TH164: {
      floor: "U3",
      from: ["CP24", "CP33"],
      x: 807,
      y: 880
    },
  },
  patterns: {
    EN: [/^(?=.*[0-9])[A-Z.0-9]*$/, /^[A-Z.0-9]*$/, /^[A-Za-z.0-9]*$/],
    SP: [/^.*$/, /^.*$/, /^.*$/],
    TH: [/^(?=.*[0-9])[A-Zก-๛.0-9]*$/, /^[A-Zก-๛.0-9]*$/, /^[A-Zก-๛.0-9]*$/]
  },
  slug: "pridi"
};
